export * from './src/mygenius.data';
export * from './src/simple.mygenius.display'